export default __webpack_public_path__ + "static/media/createOneBristol.eebfc9a2.svg";